import { isNotProduction } from "../../utils/env-indicator";

export function getStripeInvoiceDashboardLink(invoiceId: string): string {
    const isTestMode = isNotProduction();

    return `https://dashboard.stripe.com/${isTestMode ? 'test/' : ''}invoices/${invoiceId}`;
};